import React from "react";
import { motion } from "framer-motion";
import { BrandLogo } from "@/components/Brand";
import { ShieldCheck, Clock, Camera, Sparkles } from "lucide-react";

const Feature = ({ icon: Icon, children }) => (
  <div className="flex items-center gap-2.5 text-[var(--fs-ink-2)]">
    <span className="grid place-items-center w-8 h-8 rounded-full bg-[var(--fs-tint)] text-[var(--fs-blue)] shrink-0">
      <Icon size={16} strokeWidth={2.2} />
    </span>
    <span className="text-sm">{children}</span>
  </div>
);

export default function Home({ onStart, onPrivacy }) {
  return (
    <div className="min-h-[100dvh] bg-[var(--fs-page)]">
      <div className="fs-container pt-10 pb-16">
        <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <BrandLogo className="h-20 sm:h-24 mx-auto" />
          <p className="text-center mt-4 fs-eyebrow tracking-[0.18em] text-[var(--fs-blue)]" data-testid="home-subtitle">
            Skin Analyzer
          </p>
          <p className="text-center text-sm text-[var(--fs-muted)] mt-1">Analisi cosmetica visiva della pelle</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, delay: 0.1 }}
          className="mt-9 text-center"
        >
          <h1 className="text-3xl sm:text-4xl font-bold text-[var(--fs-ink)] leading-tight" data-testid="home-headline">
            Scopri cosa racconta la tua pelle.
          </h1>
          <p className="mt-4 text-base text-[var(--fs-ink-2)] leading-relaxed">
            Fotografie guidate e alcune domande ci aiutano a creare il tuo profilo cosmetico visivo.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, delay: 0.2 }}
          className="mt-8 fs-card p-6 shadow-sm"
        >
          <div className="space-y-3.5">
            <Feature icon={Camera}>Tre fotografie guidate del viso</Feature>
            <Feature icon={Sparkles}>Un profilo cosmetico chiaro e onesto</Feature>
            <Feature icon={ShieldCheck}>Nessuna registrazione richiesta</Feature>
          </div>

          <button onClick={onStart} className="fs-btn-primary w-full py-4 mt-6 text-base fs-focus" data-testid="start-skin-check-button">
            INIZIA IL MIO SKIN CHECK
          </button>

          <div className="flex items-center justify-center gap-1.5 mt-3 text-sm text-[var(--fs-muted)]">
            <Clock size={14} /> Circa 3 minuti · Non serve registrarsi.
          </div>
        </motion.div>

        <p className="mt-8 text-xs text-center text-[var(--fs-muted)] leading-relaxed px-2" data-testid="home-disclaimer">
          Il servizio effettua esclusivamente un'analisi cosmetica visiva e non costituisce diagnosi medica.
        </p>
        <div className="mt-4 text-center">
          <button onClick={onPrivacy} className="text-xs text-[var(--fs-blue)] underline underline-offset-2 fs-focus rounded" data-testid="home-privacy-link">
            Leggi l'informativa privacy
          </button>
        </div>
      </div>
    </div>
  );
}
